/**
 * BondInfoSection - Bond amount, requested by, callback phone
 */

import { OathInput } from '../../../shared/OathUI';
import CurrencyInput from '../shared/CurrencyInput';
import PhoneInput from '../shared/PhoneInput';
import { LARGE_BOND_FIELD_LIMITS } from '../shared/largeBondConstants';

const BondInfoSection = ({ formState, dispatch, disabled }) => {
  const set = (field) => (val) => dispatch({ type: 'SET_FIELD', field, value: val });

  return (
    <div>
      <h4 className="font-medium text-gray-900 dark:text-white mb-3">Bond Information</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
        <CurrencyInput
          label="Bond Amount"
          value={formState.bondAmount}
          onChange={set('bondAmount')}
          required
          disabled={disabled}
        />
        <OathInput
          label="Requested By"
          value={formState.requestedBy}
          onChange={set('requestedBy')}
          placeholder="Agent name"
          required
          disabled={disabled}
          maxLength={LARGE_BOND_FIELD_LIMITS.REQUESTED_BY}
        />
        <PhoneInput
          label="Callback Phone"
          value={formState.callbackPhone}
          onChange={set('callbackPhone')}
          required
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default BondInfoSection;
